import type { HTMLAttributes } from "react";

// Cartão padrão do app original: fundo card, borda border, radius 16, p-16.
export function Card({
  className = "",
  ...rest
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={`rounded-(--radius-app) border border-border bg-card p-4 ${className}`}
      {...rest}
    />
  );
}
